import { __ } from '@wordpress/i18n';

// tools
import handleErrorAndDisplay from './handleErrorAndDisplay';

/**
 * Turns a failed action into exactly one message.
 *
 * A 403 on an action endpoint is the backend refusing the role (`capabilities.py`),
 * not a dead session — NetworkService already tells the two apart and only ends
 * the session for the latter. The UI hides the controls a role cannot use, so a
 * denial here means the role changed under us: the caller is told to refresh it.
 *
 * @param   {object} error            the rejected request
 * @param   {string} fallbackMessage  what to say for anything that is not a denial
 * @returns {boolean} true when the action was denied, so the role can be refetched
 */
const handleActionError = (error, fallbackMessage) => {
    // The session died and the user is already being sent to the login page.
    if (error?.handled) return false;

    if (error?.status === 403) {
        handleErrorAndDisplay(
            __('Il tuo ruolo nel progetto non consente questa azione.', 'soundbetween')
        );

        return true;
    }

    handleErrorAndDisplay(fallbackMessage || __('Operazione non riuscita.', 'soundbetween'));

    return false;
}

export default handleActionError;
